import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from 'react-select';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

import PhoneInput from '../../FormComponents/PhoneInput';

import utils from '../../../lib/utils';

const othernotificationModes = [
  {
    label: 'Email only',
    value: ['EMAIL'],
  },
  {
    label: 'SMS only',
    value: ['SMS'],
  },
  {
    label: 'Email and SMS',
    value: ['EMAIL', 'SMS'],
  },
];

const weavenotificationModes = [
  {
    label: 'Email only',
    value: ['EMAIL'],
  },
];

const staff_notification_domains = [
  'BOOKER',
  'BOULEVARD',
  'MINDBODY',
  'NEXHEALTH',
  'PHOREST',
];

const vmtimeoutDurationOptions = [
  {
    label: '10 mins',
    value: 'PT10M',
  },
  {
    label: '20 mins',
    value: 'PT20M',
  },
  {
    label: '30 min',
    value: 'PT30M',
  },
  {
    label: '1 hour',
    value: 'PT1H',
  },
];

const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 3,
  }),
  control: (provided) => ({
    ...provided,
    minHeight: '50px',
    borderColor: '#cfd0d1',
  }),
};

const getSelectedOption = (options, value) => {
  return options.find((option) => option.value === value) || null;
};

export default function Notifications({
  details,
  errors,
  onChange,
  intentChange,
  setRef,
  disabled,
  intents,
  auth,
  softwares,
  preferences,
}) {
  const { isSchemaFetched, schema } = preferences;
  const notificationModes = softwares?.is_truelark ? othernotificationModes : weavenotificationModes;
  const selectedVmtimeut = getSelectedOption(
    vmtimeoutDurationOptions,
    details?.vm_time_out,
  );
  const onNotificationModeChange = (item) => {
    onChange({
      target: {
        name: 'notification_mode',
        value: item.value,
      },
    });
  };

  const onNotifyStaffSameDayChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'is_notify_staff_for_same_day_events',
        checked: !details.is_notify_staff_for_same_day_events,
      },
    });
  };

  const onIntentReportStatusChange = (id) => {
    intentChange({
      target: {
        name: 'receive_immediately',
        value: id,
      },
    });
  };

  const checkIfElementExists = (id, group) => {
    if (group.includes(id)) {
      return id;
    }
    return null;
  };
  const checkIfElementExistsinDailyReport = (id, group) => {
    if (group.includes(id)) {
      return null;
    }
    return id;
  };
  const filterBasedOnDomain = (intents) => {
    const bzsW =
      auth.booking_software && auth.booking_software !== 'undefined'
        ? auth.booking_software
        : softwares.selectedSoftware;
    const meevo_filter = ['G_BILLING_RELATED', 'G_BOOKING_CONFIRMATION'];
    let filtered_intents = intents;
    if (bzsW === 'MEEVO') {
      filtered_intents = intents.filter(
        (intent) => !meevo_filter.includes(intent.group_id),
      );
    }
    return filtered_intents;
  };
  /*
  const onAllowMBWelcomeEmailChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'allow_mindbody_welcome_email',
        checked: !details.allow_mindbody_welcome_email,
      },
    });
  };

  const onAllowMBAppointmentEmailChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'allow_mindbody_appointment_email',
        checked: !details.allow_mindbody_appointment_email,
      },
    });
  };
  */
  const onSelecChnage = (index) => {
    let current_state = [...selected];
    current_state[index] = current_state[index] === 0 ? 1 : 0;
    setSelected(current_state);
  };
  const initoptions = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  const [selected, setSelected] = useState(initoptions);
  const notification_phone =
    details.notification_phone && details.notification_phone.length > 0
      ? details.notification_phone[0]
      : '';
  return (
    <div className="notifications">
      {schema?.notification_mode && (
        <div className="notifications-top-row">
          <p className="notifications-top-row__label head-label">
            What is the best way to reach you with an urgent request from a
            guest?
          </p>
          <div
            className="notifications__row__input"
            ref={(c) => {
              setRef(c, 'notification_mode');
            }}
          >
            <Select
              name="notification_mode"
              value={notificationModes.filter((option) => (
                utils.arrayEquals(option.value, details.notification_mode)
              ))}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={notificationModes}
              onChange={onNotificationModeChange}
              className={classnames({ 'has-error': errors.notification_mode })}
              disabled={disabled}
            />
            <span className="message--small message--error">
              {errors.notification_mode && errors.notification_mode.message}
            </span>
            {details.notification_mode.includes('EMAIL') ? (
              <div>
                <input
                  type="text"
                  name="notification_email"
                  placeholder="Enter comma separated emails"
                  value={details.notification_email}
                  onChange={onChange}
                  className={classnames({
                    'has-error': errors.notification_email,
                  })}
                  ref={setRef}
                  disabled={disabled}
                />
                <span className="message--small message--error">
                  {errors.notification_email &&
                    errors.notification_email.message}
                </span>
              </div>
            ) : (
              undefined
            )}
            {details.notification_mode.includes('SMS') ? (
              <div
                className="business-phone"
                ref={(c) => {
                  setRef(c, 'notification_phone');
                }}
              >
                <PhoneInput
                  placeholder="Enter phone number"
                  name="notification_phone"
                  value={notification_phone}
                  onChange={onChange}
                  className={classnames({
                    'has-error': errors.notification_phone,
                  })}
                  disabled={disabled}
                />
                <span className="message--small message--error">
                  {errors.notification_phone &&
                    errors.notification_phone.message}
                </span>
              </div>
            ) : (
              undefined
            )}
          </div>
        </div>
      )}
      {auth &&
        auth.booking_software &&
        staff_notification_domains.includes(auth.booking_software) &&
        schema?.is_notify_staff_for_same_day_events && (
          <div className="additional-padding special-row">
            <p className="special-row__label">
              Do you want TrueLark to send notifications to staff members for
              same day appointments, cancellations and reschedules?
            </p>
            <div className="notifications__row__input special-row__input">
              <ToggleSwitch
                checked={!!details.is_notify_staff_for_same_day_events}
                name="is_notify_staff_for_same_day_events"
                onChange={onNotifyStaffSameDayChange}
                disabled={disabled}
              />
            </div>
          </div>
      )}
      <div className="manage-notification">
        <div className="manage-notification__header">
          <div className="title">Manage your notifications</div>
          <div className="description">
            Set frequency and curate which notifications are most important for
            you.
          </div>
        </div>
        <div className="table-header">
          <div className="description">Notification Type</div>
          <div className="tab">
            Receive Immediately
          </div>
        </div>
        {filterBasedOnDomain(intents).map((option, index) => {
          return (
            <div className="table-content">
              <div className="description">{option.description}</div>
              <div className="tab">
                <ToggleSwitch
                  checked={checkIfElementExists(
                    option.group_id,
                    details.receive_immediately,
                  )}
                  value={option.group_id}
                  onChange={() => onIntentReportStatusChange(option.group_id)}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="bookings__row">
        <p className="bookings__row__label">
          <span className="title">How long should TrueLark wait after sending an SMS before notifying your business that a customer who left a voicemail hasn’t responded?</span>
        </p>
        <div className="bookings__row__input">
          <Select
            value={selectedVmtimeut}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
            options={vmtimeoutDurationOptions}
            styles={customStyles}
            onChange={(e) => onChange({
              target: {
                name: 'vm_time_out',
                value: e.value,
                type: 'dropdown',
              },
            })}
            disabled={disabled}
            placeholder="Select Auto VM timeout duration"
            isClearable
          />
          <span className="message--small message--error">
            {errors.vm_time_out && errors.vm_time_out.message}
          </span>
        </div>
      </div>
      {/* <div className="preferences--separator" /> */}

      {/* <div className="notifications__row">
        <p className="notifications__row__label">
          Would you like to send your guests an email booking confirmation?
        </p>
        <div className="notifications__row__input">
          <ToggleSwitch
            checked={!!details.allow_mindbody_appointment_email}
            name="allow_mindbody_appointment_email"
            onChange={onAllowMBAppointmentEmailChange}
          />
        </div>
      </div> */}

      {/* <div className="preferences--separator" /> */}

      {/* <div className="notifications__row">
        <p className="notifications__row__label">
          Would you like to send new guests a welcome email?
        </p>
        <div className="notifications__row__input">
          <ToggleSwitch
            checked={!!details.allow_mindbody_welcome_email}
            name="allow_mindbody_welcome_email"
            onChange={onAllowMBWelcomeEmailChange}
          />
        </div>
      </div> */}
    </div>
  );
}

Notifications.defaultProps = {
  onChange: () => { },
  setRef: () => { },
  details: {},
  errors: {},
  disabled: false,
};

Notifications.propTypes = {
  onChange: PropTypes.func,
  setRef: PropTypes.func,
  details: PropTypes.shape(),
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};
